import image1 from '../../../../assets/images/work/vale-hrp/Vale HRP_detailed_img_1.webp';
import image2 from '../../../../assets/images/work/vale-hrp/Vale HRP_detailed_img_2.webp';
import image4 from '../../../../assets/images/work/vale-hrp/Vale HRP_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';

const Data_ValeHRP = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      For many workers, their first time underground introduces a completely new environment filled with
                      unfamiliar hazards. Limited exposure before entry can make it difficult to recognize risks, follow
                      site-specific safety practices, and understand how to safely move and communicate in active mining
                      areas.
                      <br />
                      <br />
                      Taking workers underground for training presents logistical challenges. Cage rides require scheduling,
                      production downtime, and coordination-making it difficult to provide consistent, repeatable hazard
                      awareness before workers enter the mine for the first time.
                    </p>
                  </div>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The challenge was creating an experience that accurately reflects the realities of working underground
                      without placing workers at risk. Training needed to cover a wide range of hazards, site safety practices,
                      and operational behaviors-while remaining engaging, accessible, and easy to deploy as part of Vale's
                      learning and development programs.
                      <br />
                      <br />
                      The solution also needed to support different learning objectives, from first-time exposure and
                      awareness to refresher training for experienced workers, all while aligning with Vale's safety culture
                      and procedures.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    Experience the hazards before going underground.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      The Vale Hazard Recognition Program is an immersive training experience designed to prepare workers
                      for underground environments before they ever step into the cage. By recreating a realistic mine,
                      users can explore, observe, and identify hazards while learning essential safety practices in a
                      controlled setting.
                      <br />
                      <br />
                      The program gives workers time to build situational awareness, understand expectations, and develop
                      confidence-without the pressure and risks associated with live underground exposure.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Learning Through Perspective</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      To strengthen awareness, the experience includes scenarios that present hazards from multiple
                      perspectives. Users can step into the role of a scoop operator, then switch viewpoints to understand
                      how the same environment looks and feels from the perspective of a worker on foot. This approach helps
                      reinforce shared responsibility, line-of-sight awareness, and safe interaction between people and
                      equipment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Vale HRP project screenshot 7" loading="lazy" decoding="async" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Vale HRP project screenshot 8" loading="lazy" decoding="async" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">A Comprehensive Safety Experience</h2>

                  <div className="paragraph dark-1">
                    <p>
                      The program encompasses a wide range of learning modules designed to generate awareness and reinforce
                      safe behavior underground. Users learn proper hazard recognition, site safety expectations, tagging
                      in and out procedures, and correct radio communication practices. A guided tour mode introduces the
                      mining lifecycle, helping workers understand how different activities and roles intersect underground.
                      <br />
                      <br />
                      Dedicated training experiences also cover emergency preparedness, including hands-on instruction for
                      setting up and using SCBA self-contained breathing devices-ensuring workers understand proper procedures
                      before they are ever required in real situations.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>Realistic underground hazard identification and awareness training</li>
                      <li>Safety practices, communication protocols, and tagging procedures</li>
                      <li>Perspective-based learning for equipment operators and workers</li>
                      <li>Guided mine tour covering the mining lifecycle</li>
                      <li>SCBA setup and emergency preparedness training</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Vale HRP project screenshot 9" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      The Vale Hazard Recognition Program is now used by Vale's learning and development teams to make safety
                      education more meaningful and effective. By giving workers exposure to underground conditions before
                      entry, the program helps reduce uncertainty, reinforce safe behaviors, and improve hazard awareness
                      across experience levels.
                      <br />
                      <br />
                      The experience also serves as a powerful refresher tool, allowing workers to revisit critical safety
                      concepts and emergency procedures without the logistical constraints of underground access.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>PC VR</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>Vale Canada</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">WEBSITE</h4>
                    <div className="paragraph light-1">
                       <p><a href="https://vale.com/sudbury" target="_blank" rel="noreferrer">
                          www.vale.com/sudbury
                        </a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_ValeHRP;

